import { useMutation, useQueryClient } from "@tanstack/react-query";

import { processResponse } from "Infrastructure/Api/ApiUtils";
import { putUserNotificationsReadAll } from "Notifications/Api/notificationApi";
import { NOTIFICATIONS_QUERY_KEYS } from "Notifications/Api/Queries/queryKeys";

export function useMarkAllAsReadMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: processResponse(() => putUserNotificationsReadAll()),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: NOTIFICATIONS_QUERY_KEYS.all,
      });
    },
  });
}
